<template>
  <div class="area">
    <div
      class="area-now"
      :style="{ backgroundImage: `url(${item.backing})` }"
      v-for="(item, i) in dqlist"
      :key="i"
    >
      <div>
        <img :src="item.imag" alt="" />
      </div>
      <span :style="{ color: item.color }">{{ item.name }}</span>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dqlist: [
        {
          name: "隐患区域",
          imag: require("../../assets/yh.png"),
          color: "#ffc521",
          backing: require("../../assets/yhqy.png"),
        },
        {
          name: "风险区域",
          imag: require("../../assets/wx.png"),
          color: "#ff0000",
          backing: require("../../assets/fxqy.png"),
        },
      ],
    };
  },
  methods: {},
};
</script>
<style lang="less" scoped>
.area {
  width: 13vw;
  height: 8vh;
  position: absolute;
  bottom: 30%;
  right: 20%;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
  background-image: url("../../assets/bj.png");
  background-size: 100% 100%;
}
.area-now {
  width: 40%;
  height: 60%;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
  div {
    width: 2vw;
    height: 4vh;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 60%;
      height: auto;
    }
  }
  span {
    font-size: 0.8vw;
    color: #fff;
  }
}
</style>